
    <app-kontable
      title="{{ 'layout.layout' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="layouts"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-layout-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [layout]="addEditLayout"
      (hide)="toggleShow()"
      (saveLayout)="saveLayout($event)"
      [printTypes]="layoutPrintTypes"
      [tillTypes]="layoutTillTypes"
      [templates]="layoutTemplates"
      [layoutDetailRowPositions]="layoutDetailRowPositions">
    </kv-promo-layout-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/layout/layout.component.ts.LayoutComponent.html